import { createContext, useContext } from 'react';
const defaultContext = {
    colorMode: 'light',
    setColorMode: () => { },
};
export const ThemeContext = createContext(defaultContext);
export const useTheme = () => useContext(ThemeContext);
